export default __webpack_public_path__ + "static/media/flixxo-white.2f5e8ae9.svg";